<!-- Tab图文信息展示列表：模块头+Tab按钮+图片+标题+内容 -->
<template>
<div class="content-block">
  <div class="info-list-title">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <ul class="list-tab-ul" v-if="tabList.length>0">
      <li v-for="(tab, index) in tabList" v-bind:class="['list-tab-li',tab.id==defaultTab ?'active' : '']" v-on:click="selectedAct(tab.id)">{{tab.title}}</li>
    </ul>
    <router-link :to="'/sghq/jghq'">更多</router-link>
  </div>
  <div class="info-list-content">
    <div class="list-container">
      <div class="list-container-cell" v-for="info in infoList" :style="{'width': celWidth}">
        <router-link :to="'/sghq/hqDetail/'+info.id">
          <div class="cell-left-info">
            <div class="cell-base-info">
              <div class="base-info-title">{{info.name.length>titleLength?info.name.substring(0,titleLength)+"...":info.name}}</div>
              <div class="base-info-label">所在产地：{{info.dependency.length>30?info.dependency.substring(0,30)+"...":info.dependency}}</div>
              <div class="base-info-label2">{{info.create_time.substring(0,10)}}</div>
            </div>
            <div class="cell-col-info">
              <table cellpadding="2" cellspacing="0" >
                <tr>
                  <th>近期价值</th>
                  <th>周涨跌幅</th>
                  <th>月涨跌幅</th>
                </tr>
                <tr>
                  <td class="price">{{info.price}}</td>
                  <td>{{info.weekly_change}}</td>
                  <td>{{info.monthly_change}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="cell-right-info">
            <chart-line-01 :ref="'index_'+info.id" :mainId="info.id" :chartId="'index-'+info.id" title="价格走势" :legendShow=false chartWidth="100%" chartHeight="124px"  v-on:queryPage="detail_Req"/>
          </div>
        </router-link>
      </div>
      <div class="no-record-1" v-if="infoList.length<1"></div>
    </div>
  </div>
</div>
</template>

<script>
import Line01 from '../chart/Line01'
export default {
  name: 'ChartTabList01',
  components: {'chart-line-01': Line01},
  props: {
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: Number,
      default: 16
    },
    label: {
      type: String,
      default: ''
    },
    col: {
      type: String,
      default: '3'
    },
    count: {
      type: String,
      default: '4'
    }
  },
  data () {
    return {
      msg: '',
      celWidth: 'calc(100%/' + this.col + ')',
      tabList: [{title: '产地价格', id: 1}, {title: '市场价格', id: 2}],
      defaultTab: 1,
      infoList: []
    }
  },
  methods: {
    selectedAct: function (id) {
      this.defaultTab = id
      this.queryPage(this.defaultTab)
    },
    queryPage: function (tabId) {
      let that = this
      let params = {page: 1, pageSize: 4, objectId: 930}
      params.type = this.defaultTab
      // console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.priceDataLists(params).then(res => {
        that.msg = res.msg
        that.infoList = res.data.list
        // console.log('首页行情：结束请求Vue-axios：'+JSON.stringify(res))
      })
    },
    detail_Req (rePar) {
      // console.log('chart回调Vue-axios：'+rePar.chartId);
      let that = this
      let params = {objectId: rePar.id, type: 1}
      that.$dataApi.priceDetail(params).then(res => {
        // console.log('chart回调Vue-axios：'+JSON.stringify(res));
        that.msg = res.msg
        // that.detailInfo=res.data.detail;
        // that.tableData=res.data.table_data;
        that.chartData = res.data.e_chart
        // console.log('chart回调Vue-axiosthat.$refs：'+JSON.stringify(rePar));
        let charId = 'index_' + rePar.id
        let childObj = eval('that.$refs.index_' + rePar.id)[0]
        childObj.drawLine(that.chartData.axis, [that.chartData.data])
      })
    }
  },
  created: function () {
    this.queryPage(this.defaultTab)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
a {
  color: #42b983;
  text-decoration: none;
}

.list-tab-ul {
  display:block;
  position:absolute;
  top:7px;
  left: 240px;
  heith:40px;
  list-style-type: none;
  padding: 0;
  //background:red;
}

.list-tab-li {
  float: left;
  margin: 0px 4px 0px 0px;
  height: 30px;
  width: 80px;
  color: #000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}

.list-tab-ul .active{
  color: #ffffff;
  background: var(--color7);
}

.list-container {
  display: flex;
  flex-wrap: wrap;
}

.list-container-cell {
  box-sizing: border-box;
  height: 170px;
  background: #fff;
  border: 0px solid red;
}

.list-container-cell a {
  display:flex;
  box-sizing: border-box;
  padding:8px;
  margin:4px;
  background-color: #fff;
  border:1px solid #ddd;

}

.list-container-cell a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px var(--color6);
}

.list-container-cell a:hover .base-info-title{
  color: var(--color6);
}

.cell-left-info{
  width:50%;
}

.cell-right-info{
  width:50%;
  background:#fff;
}

.list-container-cell .cell-base-info{
  position:relative;
  height:80px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  position:relative;
  height:30px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  position:relative;
  height:40px;
  font-size:12px;
  line-height:20px;
  color:#888;
  padding-left:18px;
  background-image:url(./../../assets/location.png);
  background-size: 17px 17px;
  background-repeat: no-repeat;
  background-position: 0px 3px;
}

.cell-base-info .base-info-label2{
  position:relative;
  height:20px;
  padding-left:18px;
  font-size:12px;
  line-height:20px;
  color:#888;
  //background:red;
  background-image:url(./../../assets/clock.png);
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 0px 2px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:50px;
  padding-top:5px;
  margin-top:15px;
  background-color: #fff;
  border-top:1px solid #ddd;
}

.cell-col-info table{
  width:100%;
  height:40px;
  text-align:center;
}

.cell-col-info table th{
  font-size:12px;
  color:#888;
  font-weight:400;
  border-left:1px solid #ddd;
}

.cell-col-info table th:first-child{
  border-left:0px;
}

.cell-col-info table td{
  font-size:16px;
  font-weight:600;
  color:#000;
  border-left:1px solid #ddd;
}

.cell-col-info table td:first-child{
  border-left:0px;
}

.cell-col-info table td span{
  padding:2px;
  margin-left:4px;
  font-size:12px;
  background:orange;
  color:#fff;
}
.cell-col-info .price{
  color:red;
}

</style>



// WEBPACK FOOTER //
// src/components/block/ChartTabList01.vue